import { Card, Container } from "react-bootstrap";
import PageHeader from "../../components/PageHeader";

const ContactUs = () => {
  return (
    <>
      <Container className="w-800 mt-5 pb-5">
        <PageHeader title="Contact Us" />
        <Card>
          <Card.Body>
            <section className="mb-5">
              <h3 className="text-primary">Email</h3>
              <p className="leading-para">
                <a className="text-secondary" href="mailto:support@mytaxclub.in">
                  support@mytaxclub.in
                </a>
              </p>
            </section>
            <section className="mb-5">
              <h3 className="text-primary">Phone</h3>
              <p className="leading-para">
                <a className="text-secondary" href="tel:+91123456789">
                  +91 123456789
                </a>
              </p>
            </section>
            <section>
              <h3 className="text-primary">Office Address</h3>
              <p className="leading-para">
                AuditEdge Technologies Pvt. Ltd. 1/C, 83/1, T-Hub Foundation, Knowledge City,
                Raidurg, Hyderabad, Hyderabad, Rangareddy, Telangana, 500081
              </p>
            </section>
          </Card.Body>
        </Card>
        <p className="leading-para text-end">
          For more info{" "}
          <span
            role="button"
            className="text-primary text-decoration-underline"
            onClick={() => window.open(`https://mytaxclub.in/contact-us/`, "_blank")}
          >
            Click Here
          </span>
        </p>
      </Container>
    </>
  );
};

export default ContactUs;
